import React from "react";
import OrderDeliveryFormPageContainer from "./OrderDeliveryFormPageContainer";

export class OrderDeliveryFormPage extends React.Component {
  render() {
    return <OrderDeliveryFormPageContainer {...this.props} />;
  }
}
